import React from 'react';
import { Container } from './UserActivityDetail';

export const UserActivityDetailSkeleton = () => {
  return (
    <Container>
      <div className="min-h-[48px] min-w-[48px] flex-shrink-0 animate-pulse rounded-full bg-neutral300" />
      <div className="flex h-[46px] w-[187px] flex-col justify-between md:w-[200px]">
        <div className="min-h-[19px] min-w-full flex-shrink-0 animate-pulse rounded-md bg-neutral300" />
        <div className="min-h-[19px] w-[120px] flex-shrink-0 animate-pulse rounded-md bg-neutral300" />
      </div>
    </Container>
  );
};
